import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatCalendar } from "@angular/material/datepicker";
import { select, Store } from "@ngrx/store";
import { Subscription } from "rxjs";
import { ContractDto } from "src/app/api/models";
import { AppState, getState } from "src/app/state/app.state";
import { setTitle } from "../../title/state/title.actions";
import { setAgreementChecked } from "../../transaction-info/state/transaction-info.actions";
import { getSysParams, submitAdmissionDate } from "../state/admission-date.action";
import { getMaxDate, getMinDate, } from "../state/admission-date.selector";


export const MY_FORMATS = {
	parse: {
		dateInput: "DD/MM/YYYY",
	},
	display: {
		dateInput: "DD/MM/YYYY",
		monthYearLabel: "YYYY",
		dateA11yLabel: "LL",
		monthYearA11yLabel: "YYYY",
	},
};
@Component({
    selector: "app-admission-date",
    templateUrl: "./admission-date.component.html",
    styleUrls: ["./admission-date.component.scss"],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class AdmissionDateComponent implements OnInit {
	exampleHeader = ExampleHeader;
	public minDate: Date;
	public maxDate: Date;
	public selectedDate: Date = new Date();

	private contract: ContractDto;
	private subs: Subscription[] = [];

	constructor(private store: Store<AppState>, private _adapter: DateAdapter<any>) {
		this.subs.push(getState(this.store).subscribe(state=> {
			this._adapter.setLocale(state.transactionInfo.selectedLanguage.languageCode.toLowerCase());
			this.contract = state.transactionInfo.selectedContract;
		}));
		this.store.dispatch(getSysParams());
	}

	ngOnInit(): void {
		this.store.dispatch(setTitle({data: "TITLE_ADMISSION_DATE",data2: "TITLE_ADMISSION_DATE_INFO",}));

		this.subs.push(
			this.store.pipe(select(getMinDate)).subscribe((minDate) => {
				this.minDate = minDate;
			})
		);

		this.subs.push(
			this.store.pipe(select(getMaxDate)).subscribe((maxDate) => {
				this.maxDate = maxDate;
			})
		);
	}

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}

	public onClickRetour() {
		this.store.dispatch(setAgreementChecked({ data: undefined }));
	}

	public dateValid() {
		return this.minDate !== undefined && this.maxDate !== undefined && this.selectedDate <= this.maxDate && this.selectedDate >= this.minDate;
	}

	public onClickOk() {
		if (this.dateValid()) {
			this.store.dispatch(submitAdmissionDate({ admissionDate: this.selectedDate, contractId: this.contract.contractId }));
		}
	}
}

/** Custom header component for datepicker. */
@Component({
    selector: "example-header",
    styles: [],
    template: `
		<div class="row align-items-center mb-2 mx-0">
			<button class="col" mat-stroked-button (click)="previousClicked()">
				{{ 'PREVIOUS_MONTH' | translated }}
			</button>
			<div class="col text-center">{{ periodLabel }}</div>
			<button class="col" mat-stroked-button (click)="nextClicked()">
				{{ 'NEXT_MONTH' | translated }}
			</button>
		</div>
	`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExampleHeader<D> implements OnDestroy {
	private subs: Subscription[] = [];

	constructor(private _calendar: MatCalendar<D>, private _dateAdapter: DateAdapter<D>, private cdr: ChangeDetectorRef) {
		this.subs.push(_calendar.stateChanges.subscribe(() => cdr.markForCheck()));
	}

	ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}
	
	get periodLabel() {
		return this._dateAdapter.format(this._calendar.selected as D, "DD/MM/YYYY").toLocaleUpperCase();
	}

	previousClicked() {
		this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1);
		this.cdr.markForCheck();
	}

	nextClicked() {
		this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1);
		this.cdr.markForCheck();
	}
}
